<template>
    <v-container style="position: relative;">
        <div class="support-info">
        <h1>Support</h1>
        <p>Need help? Reach out to us at any time.</p>

        <h3>IT Help Desk</h3>
        <p><v-icon>mdi-email-outline</v-icon> <a href="mailto:helpdesk@adelphi.edu">helpdesk@adelphi.edu</a></p>
        <p><v-icon>mdi-phone</v-icon> <a href="tel:516.877.3340">516.877.3340</a></p>
        </div>
        <div class="support-bkg"></div>
    </v-container>
</template>
<script>
export default {
    data: () => ({
        
    }),
}
</script>
<style scoped>
.support-bkg {
    width: 616;
    height: 523px;
    background-image: url('~@/assets/support-bkg.png');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: bottom right;
}
</style>
